import { Component, QueryList, ViewChildren, ViewEncapsulation, OnInit } from "@angular/core";
import { TableLazyLoadEvent } from "primeng/table";
import { HttpClient, HttpParams } from "@angular/common/http";
import { env } from "@environments/environment";
import { PAGINATION_OPTIONS } from "@app/components/supplies/supplies.component";
import { Router } from "@angular/router";
import { DataService } from "@app/services/data.service";
import { Tooltip } from "primeng/tooltip";
import { StatusTranslatorService } from "@app/services/status.translator.service";

@Component({
  selector: "app-distributionsMzu",
  templateUrl: "./distributions.mzu.component.html",
  styleUrls: ["/distributions.mzu.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DistributionsMzuComponent implements OnInit {

  constructor(private http: HttpClient,
              private router: Router,
              public statusTranslatorService: StatusTranslatorService,
              public dataService: DataService) {}

  @ViewChildren(Tooltip) tooltips!: QueryList <Tooltip>;

  distributions: any[] = [];
  selectedPageNumber = 1;
  pageSize = 10;
  totalRows = 0;
  tabHeader: {key: string; label: string;}[] = [
    { key: "lovId", label: "LOV ID" },
    { key: "mnnId", label: "МНН ID" },
    { key: "id", label: "Номер розподілу" },
    { key: "orderDate", label: "Дата розподілу" },
    { key: "originalAuthorName", label: "Виконавець розподілу" },
    { key: "status", label: "Статус" },
    { key: "direction", label: "Напрям" },
    { key: "subDirection", label: "Піднапрям" },
    { key: "signs", label: "Підписи" },
    { key: "agreementNumber", label: "Номер договору" },
    { key: "mnn", label: "МНН" },
    { key: "dosage", label: "Дозування" },
    { key: "tradeName", label: "Торгова назва" },
    { key: "distributedQuantity", label: "Розподілена кількість" },
    { key: "measure", label: "Одиниця виміру" },
    { key: "unitPrice", label: "Вартість за одиницю, грн" },
    { key: "totalPrice", label: "Загальна вартість, грн" },
    { key: "pdv", label: "Ставка ПДВ" },
    { key: "totalPriceWithPDV", label: "Загальна вартість з ПДВ, грн" },
    { key: "deliveredQuantity", label: "Кількість розвезено" },
    { key: "totalDeliveredPriceWithPDV", label: "Сума розвезення з ПДВ, грн" },
    { key: "deliveredAndDistributed", label: "Розвезено/Розподілено" },
    { key: "warehouseName", label: "Склад" },
    { key: "4", label: "Відмова" },
    { key: "until", label: "Відтермінування до" },
  ];

  tableState: TableLazyLoadEvent = {};
  content = "";
  loadingCounter = 0;
  protected readonly paginationOptions = PAGINATION_OPTIONS;

  ngOnInit(): void {

    this.loadColumnOrder();
  }

  saveColumnOrder() {
    localStorage.setItem("distributionMzuColumnOrder", JSON.stringify(this.tabHeader));
  }

  loadColumnOrder() {
    const savedOrder = localStorage.getItem("distributionMzuColumnOrder");
    if (savedOrder) {
      this.tabHeader = JSON.parse(savedOrder);
    }
  }

  loadData($event: TableLazyLoadEvent) {
    this.tableState = $event;
    this.getDistributions(this.selectedPageNumber, $event.sortOrder === 1 ? "asc" : "desc", $event.sortField?.toString());
  }

  getDistributions(
    page: number | undefined,
    order = "desc",
    field = "id",
  ): void {
    let params = new HttpParams();
    this.selectedPageNumber = page ? page : 0;
    const sortFieldAndOrder = `${field},${order}`;
    params = params.append("page", this.selectedPageNumber - 1);
    params = params.append("size", this.pageSize);
    params = params.append("sort", sortFieldAndOrder);

    const timeoutId = setTimeout(() => {
      this.loadingCounter++;
    }, 300);

    this.http.get<{ [key: string]: any; }>(env.logisticsServiceBackend + "/logistics/v1/distributions/registry-mzu", { params }).subscribe(data => {
      this.distributions = data["content"];
      this.totalRows = data["totalElements"];
      if (this.loadingCounter === 0) {
        clearTimeout(timeoutId);
      } else {
        this.loadingCounter--;
      }
    });
  }

  pageChange(pageNumber: number) {
    this.selectedPageNumber = pageNumber;
    this.loadData(this.tableState);
  }

  pageSizeChanged(pageSize: number) {
    this.pageSize = pageSize;
    this.selectedPageNumber = 1;
    this.loadData(this.tableState);
  }

  getFirstShowedRowIndex() {
    return this.selectedPageNumber === 1 ? 0 : (this.selectedPageNumber - 1) * this.pageSize;
  }

  goToDistribution(distributionId: string) {
    if (this.dataService.userRoleValue.getValue() === "DOZ") {
      this.router.navigate(["/distributions/doz/view/" + distributionId]);
    } else {
      this.router.navigate(["/distribution/view/" + distributionId]);
    }
  }

  getPathToStatusImg(rowElement: string): string {
    let color: string;
    switch (rowElement) {
    case "DRAFT": color = "grey"; break;
    case "PENDING_APPROVAL": color = "yellow"; break;
    case "AWAITING_DOZ_DISTRIBUTION": color = "yellow"; break;
    default: color = "green";
    }
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  public getVatRate(vatRate: number): string {
    if (vatRate === 0) {
      return "Без ПДВ";
    }
    return vatRate + "%";
  }
}
